import { Card, Progress } from 'antd';
import React from 'react';

import Text from '@/atoms/Text';
import { Pill } from '@/components/common/Pill';

export interface TimelineCardProps {
  currentDate: string;
  percent: number;
  startDate: string;
  endDate: string;
}

export function TimelineCard({
  currentDate,
  percent,
  startDate,
  endDate,
}: Readonly<TimelineCardProps>): React.ReactElement {
  return (
    <Card className="timeline-card">
      <div className="card__header">
        <Text variant="h5">Timeline</Text>
        <Pill tone="neutral">Source: OpenAir</Pill>
      </div>
      <div className="timeline-card__progress-wrapper">
        <div className="timeline-card__progress-container">
          <Progress
            percent={Math.min(100, percent)}
            strokeColor={percent > 100 ? '#EF4444' : 'var(--blend-navy)'}
            trailColor="var(--surface-tertiary)"
            format={() => null}
          />
          <Text
            variant="bodySmall"
            className="timeline-card__progress-label"
            style={{ left: `${Math.min(100, percent)}%` }}
          >
            Today · {currentDate} · {percent}%
          </Text>
        </div>
      </div>
      <div className="timeline-card__dates">
        <Text variant="bodySmall" color="var(--text-secondary)">
          {startDate}
        </Text>
        <Text variant="bodySmall" color="var(--text-secondary)">
          {endDate}
        </Text>
      </div>
    </Card>
  );
}
